import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { getFormErrors } from "@saleor/utils/errors";
import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import React from "react";
import { useIntl } from "react-intl";

import { VoucherDetailsPageFormData } from "../VoucherDetailsPage";

export interface VoucherDescriptionProps {
  data: VoucherDetailsPageFormData;
  errors: DiscountErrorFragment[];
  clientErrors?: {
    description?: string;
  };
  disabled: boolean;
  variant: "create" | "update";
  onChange: (event: any) => void;
}

const VoucherDescription: React.FC<VoucherDescriptionProps> = ({
  data,
  disabled,
  errors,
  clientErrors,
  onChange
}) => {
  const intl = useIntl();

  const formErrors = getFormErrors(["description"], errors);
  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Descriptions"
        })}
      />
      <CardContent>
        <TextField
          id="descriptionTxt"
          disabled={disabled}
          error={!!formErrors.description || !!clientErrors.description}
          helperText={
            getDiscountErrorMessage(formErrors.description, intl) ||
            clientErrors.description
          }
          name={"description" as keyof VoucherDetailsPageFormData}
          onChange={onChange}
          label={intl.formatMessage({
            defaultMessage: "Descriptions",
            description: "voucher description"
          })}
          value={data.description}
          fullWidth
          multiline
          rows={2}
          rowsMax={4}
        />
      </CardContent>
    </Card>
  );
};
VoucherDescription.displayName = "VoucherDescription";
export default VoucherDescription;
